import request from '@/utils/request'

// 查询运动项目列表
export function getSportProjectList(data) {
  return request({
    url: '/sys/sport/project/list',
    method: 'post',
    data
  })
}

// 获取运动项目详细信息
export function getSportProjectInfo(id) {
  return request({
    url: '/sys/sport/project/info/'+id,
    method: 'get',
  })
}

// 修改运动项目
export function editSportProject(data) {
  return request({
    url: '/sys/sport/project/edit',
    method: 'put',
    data
  })
}

// 删除运动项目
export function delSportProject(id) {
  return request({
    url: '/sys/sport/project/del/'+id,
    method: 'delete',
  })
}

// 新增运动项目
export function addSportProject(data) {
  return request({
    url: '/sys/sport/project/add',
    method: 'post',
    data
  })
}
